'use strict';
var $ = require('../internals/export');
var ObjectIterator = require('../internals/object-iterator');

// `Object.iterateEntries` method
// https://github.com/tc39/proposal-object-iteration
$({ target: 'Object', stat: true }, {
  iterateEntries: function iterateEntries(object) {
    return new ObjectIterator(object, 'entries');
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/esnext.object.iterate-entries.js
// module id = 975
// module chunks = 1 2 3 4